import { useRef } from 'react'
import { MainBlock, EBlocks, Vacancies, PageHead, SeoFooter } from '@/components'

const Career = ({ data, vacancies }) => {
    const vacanciesRef = useRef(null)

    return (
        <>
            <PageHead meta={data.seo_meta}/>
            <MainBlock
                title={data.title}
                text={data.description}
                img={data.preview}
                buttonText="Смотреть вакансии"
                onBtnClick={() => vacanciesRef.current.scrollIntoView({ behavior: 'smooth' })}
                pb="small"
            />
            <EBlocks blocks={data.blocks} />
            <Vacancies blockRef={vacanciesRef} vacancies={vacancies} />
            {data.seo_meta.addtional_description && <SeoFooter text={data.seo_meta.addtional_description} />}
        </>
    )
}

Career.getInitialProps = async ({ api }) => {
    const { data } = await api.pageWithSlug('vacancies')()
    const vacancies = await api.vacancies()

    return { data: data, vacancies: vacancies.data }
}

export default Career
